/**
 * True in an on-prem appliance's own build (`VITE_APP_ENV=standalone`, pinned by
 * `bin/standalone-init.sh` and the OnPrem mirror workflow). Gate cloud-only surfaces on
 * this — the nav entry AND its route, so the surface is neither listed nor
 * URL-reachable on an appliance (e.g. On-Prem Clients: an appliance manages no
 * appliances; the backend's AppliancePolicy refuses there as well).
 */
export const isStandaloneEnv: boolean = import.meta.env.VITE_APP_ENV === 'standalone'

/**
 * Sanctum's CSRF cookie name for an environment — the same mapping the
 * backend applies to `APP_ENV` (`App\Support\AuthCookieNames`): production
 * keeps `XSRF-TOKEN`; every other environment is suffixed with its name, the
 * SPA's `development` being the backend's `local`. Production's auth cookies
 * are scoped to `.honestwaves.com`, the parent of every other environment's
 * host, so a browser that has used production sends them to staging and local
 * too; under the same name they shadow the local one and every login
 * dead-ends on 419.
 */
export function xsrfCookieNameFor(appEnv: string | undefined): string {
  const env = (appEnv ?? '').trim().toLowerCase()
  if (env === '' || env === 'production') return 'XSRF-TOKEN'
  return `XSRF-TOKEN-${(env === 'development' ? 'local' : env).toUpperCase()}`
}

/**
 * This deployment's CSRF cookie name: derived from `VITE_APP_ENV`, or the
 * explicit `VITE_XSRF_COOKIE_NAME` (root `.env` `FRONTEND_VITE_XSRF_COOKIE_NAME`,
 * which must then equal the backend's `SESSION_XSRF_COOKIE`).
 */
export const XSRF_COOKIE_NAME: string =
  (import.meta.env.VITE_XSRF_COOKIE_NAME as string | undefined) ||
  xsrfCookieNameFor(import.meta.env.VITE_APP_ENV as string | undefined)
